<template>
  <aside class="sidebar">
    <div class="sidebarBackdrop" @click="closeSidebarPanel" v-if="isSideBarOpen">
    </div>
    <button class="mobileCloseBtn" @click="closeSidebarPanel" v-if="isSideBarOpen">
      <CloseIcon :color="'#1E242C'" />
    </button>
    <transition name="slide">
      <section :class="['sidebarPanel', isSideBarOpen ? '' : 'sidebarPanelClose']">
        <button class="closeButton">
          <CloseIcon @click="closeSidebarPanel" />
        </button>
        <slot></slot>
      </section>
    </transition>
  </aside>
</template>

<script src="./scripts/index.js" />
<style lang="scss" src="./stylesheet/style.scss"></style>
